import { useMemo } from 'react'

import { Form } from 'factorial-form'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'

import { useLeaves } from 'modules/timeoff/lib/LeavesContextProvider'
import { leaveEmployee } from 'modules/timeoff/lib/leaveEmployees'
import type Leave from 'modules/timeoff/store/models/Leave'

class RejectForm extends Form {
  constructor(values: {}) {
    super(values, {
      reason: 'string',
    })
  }
}

interface Props {
  leave: Leave
  onClose: () => void
  onRejected?: () => void
  fromShifts?: boolean
}
interface ReturnType {
  form: RejectForm
  onSubmit: () => void
}

const useRejectLeave = ({ onClose, leave, onRejected, fromShifts = false }: Props): ReturnType => {
  const { fetchData } = useLeaves()
  const form = useMemo(() => new RejectForm({}), [])

  const { performAction: onSubmit } = useAsyncAction(async () => {
    const reason = {
      reason: form.get('reason').value,
    }

    const { success, value } = await asyncAction(() => leave.rpc('reject', reason))

    if (success) {
      track(trackingEvents.timeoff.reviewTimeOffRequestSubmit, {
        request_action: 'reject_final',
        has_rejection_message: !!reason.reason,
        from_shifts: fromShifts,
      })

      leave.set(value)
      onClose()
      fetchData(leaveEmployee(leave))

      if (onRejected) onRejected()
      return
    }

    // value is instance of Error when !success
    throw value
  })

  return {
    onSubmit,
    form,
  }
}

export default useRejectLeave
